 
 <mat-toolbar style=" max-height: 40px;text-align: center;
background-image: linear-gradient( 109.6deg,  rgb(146, 146, 146) 11.2%, rgba(28,103,88,1) 91.1% );
   
"> 
 <h1 style="text-align: center; color: white;">Building Dreams, One Project at a Time: Your Trusted General Contractor</h1>
    


      <mat-menu #mymenu="matMenu"> 
      
      </mat-menu>   
   
    </mat-toolbar>
 
  

 